
import { Vue, prop } from "vue-class-component";
import { HangingBkdSummaryConsole } from '@/domain/entities/HangingBkd';
import { formatDate } from "@/app/infrastructures/misc/Utils";

class Props {
  dataSummary = prop<HangingBkdSummaryConsole>({
    default: () => new HangingBkdSummaryConsole(),
    type: Object,
  });
}

class HeaderSummaryHangingBKDConsole extends Vue.with(Props) {
  formatDate = formatDate

  get allCards() {
    // summary cards
   return [
      {
        icon: require("@/app/ui/assets/svg/total-active-awb-hanging.svg"),
        alt: "total-active-hanging-outgoing",
        label: this.$t("dashboard.hanging.activity"),
        badge: "aktivitas",
        pending: this.dataSummary.pendingActivities,
        done: this.dataSummary.doneActivities,
        total: this.dataSummary.totalActivities,
        byStatus: []
      },
      {
        icon: require("@/app/ui/assets/svg/ic_pic_hanging.svg"),
        alt: "total-user-ops-hanging-outgoing",
        label: this.$t("dashboard.hanging.pos"),
        badge: "pos",
        pending: this.dataSummary.pendingSttPos,
        done: this.dataSummary.doneSttPos,
        total: this.dataSummary.totalSttPos,
        byStatus: this.dataSummary.byStatusPos
      },
      {
        icon: require("@/app/ui/assets/svg/del-hanging.svg"),
        alt: "total-sti-hanging-outgoing",
        label: this.$t("dashboard.hanging.subKon"),
        badge: "sub-kon",
        pending: this.dataSummary.pendingSttSubKon,
        done: this.dataSummary.doneSttSubKon,
        total: this.dataSummary.totalSttSubKon,
        byStatus: this.dataSummary.byStatusSubKon
      },
      {
        icon: require("@/app/ui/assets/svg/total-bag-hanging.svg"),
        alt: "total-bagging-hanging-outgoing",
        label: this.$t("dashboard.hanging.corporate"),
        badge: "korporate",
        pending: this.dataSummary.pendingSttKorporat,
        done: this.dataSummary.doneSttKorporat,
        total: this.dataSummary.totalSttKorporat,
        byStatus: this.dataSummary.byStatusKorporat
      },
    ];
  }
}

export default HeaderSummaryHangingBKDConsole;
